import { DEFAULT_LANGUAGE, isSupportedLanguage } from './supported-languages';

/**
 * UI language preference. One key for every portal — the switcher lives in the shared header, so a
 * user who picks Arabic in the store portal should not have to pick it again elsewhere.
 */
export const LANGUAGE_KEY = 'LYCHEE_LANGUAGE';

/** @deprecated Migrated to {@link LANGUAGE_KEY}. */
export const TAXI_OFFICE_LANGUAGE_KEY = 'TAXI_OFFICE_LANGUAGE';

/** @deprecated Migrated to {@link LANGUAGE_KEY}. */
const LEGACY_LANGUAGE_KEY = 'STORE_CRM_LANGUAGE';

export function getStoredLanguage(): string | null {
  return (
    window.localStorage.getItem(LANGUAGE_KEY) ??
    window.localStorage.getItem(TAXI_OFFICE_LANGUAGE_KEY) ??
    window.localStorage.getItem(LEGACY_LANGUAGE_KEY)
  );
}

export function setStoredLanguage(language: string): void {
  window.localStorage.setItem(LANGUAGE_KEY, language);
  window.localStorage.removeItem(TAXI_OFFICE_LANGUAGE_KEY);
  window.localStorage.removeItem(LEGACY_LANGUAGE_KEY);
}

/** Saved preference, or the default (Arabic) on a first visit. */
export function resolveLanguagePreference(): string {
  const stored = getStoredLanguage();
  return isSupportedLanguage(stored) ? stored : DEFAULT_LANGUAGE;
}

/** `Accept-Language` for API calls — follows whatever the user is reading the UI in. */
export function resolveAcceptLanguageHeader(): string {
  return resolveLanguagePreference();
}

/** @deprecated Use {@link getStoredLanguage}. */
export const getStoredTaxiLanguage = getStoredLanguage;
/** @deprecated Use {@link setStoredLanguage}. */
export const setStoredTaxiLanguage = setStoredLanguage;
/** @deprecated Use {@link resolveLanguagePreference}. */
export const resolveTaxiLanguagePreference = resolveLanguagePreference;
